// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".libraryAssetForm-module__form--GXzQG .kobo-select .kobo-select__control{min-height:38px}", "",{"version":3,"sources":["webpack://./jsapp/js/components/modalForms/libraryAssetForm.module.scss"],"names":[],"mappings":"AAGE,yEACE,eAAA","sourcesContent":[".form {\n  // Make all WrappedSelect controls the same height as a TextBox size L (38px)\n  // so all fields in this modal are visually consistent.\n  :global(.kobo-select .kobo-select__control) {\n    min-height: 38px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": "libraryAssetForm-module__form--GXzQG"
};
export default ___CSS_LOADER_EXPORT___;
